import { createAPIModule } from 'utility/redux/apiModuleHelpers';
// import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.storm.image.update;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'STORM_IMAGE_UPDATE',
	method: 'POST',
	url: '/storm/image/update.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
